import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getLocalStorageItem } from "../Utils";
function PublicAuth(props) {
  const isAuthenticated = () => {
    const user = getLocalStorageItem("accessToken");
    return user;
  };

  return isAuthenticated() ? (
    <>
      {" "}
      <Navigate to="/dashboard" />
    </>
  ) : (
    <Outlet />
  );
}
export default PublicAuth;
